import React from "react";
import { Card, CardContent, Container, Grid, Typography } from "@mui/material";
import NavBar from "../components/NavBar";
import moment from "moment";
import { Box } from "@mui/system";
import { Email, Phone } from "@mui/icons-material";

const Contacts = () => {
  return (
    <>
      <NavBar />
      <Container>
        <Grid container>
          <Grid item xs={12}>
            <Box p={2}>
              <Typography
                sx={{
                  textAlign: "center",
                }}
                variant="h2"
              >
                Contacts
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Card
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CardContent>
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  gutterBottom
                  variant="h5"
                  component="h2"
                >
                  <Phone />
                  +254 710 423 376
                </Typography>
                <Typography
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: 3,
                  }}
                  gutterBottom
                  variant="h5"
                  component="h2"
                >
                  <Email style={{}} />
                  info@hotel.gmail.com
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Box
        sx={{
          backgroundColor: "#000000",
          color: "#ffffff",
          textAlign: "center",
          padding: "4rem",
          mt: 5,
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography
                component="p"
                variant="p"
                sx={{
                  textAlign: "center",
                }}
              >
                &copy; Hotel Booking System {moment().format("YYYY")} All rights
                reserved.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Contacts;
